var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multi-line",class:_vm.element.class},_vm._l((_vm.element.elements),function(line){return _c('div',{staticClass:"line"},[_c('text-with-refs',{attrs:{"text":line.text}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }